import { Header, Link, Snackbar, factbird } from '@blackbird/ui-base';
import { Grid } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import React, { FC, PropsWithChildren } from 'react';
import { makeStyles } from 'tss-react/mui';

import Footer from '@/layout/footer';

const useStyles = makeStyles()((theme) => ({
  '@global': {
    html: {
      backgroundColor: theme.palette.primary.main,
    },
  },
  ieFlexboxFix: {
    display: 'flex',
    flexDirection: 'column',
  },
  root: {
    flexGrow: 1,
  },
  appFrame: {
    overflowX: 'hidden',
    position: 'relative',
    display: 'flex',
    width: '100%',
    height: '100%',
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: 'auto',
  },
  content: {
    width: '100%',
    overflowX: 'hidden',
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    marginTop: 56,
    [theme.breakpoints.up('sm')]: {
      padding: 24,
      marginTop: 64,
    },
  },
  flexibleFooter: {
    minHeight: '100vh',
    flexDirection: 'column',
    display: 'flex',
    flexGrow: 1,
    flexBasis: 'auto',
  },
  logo: {
    height: '100%',
    display: 'inline-block',
    [theme.breakpoints.only('xs')]: {
      display: 'none',
    },
    paddingLeft: 16,
    verticalAlign: 'middle',
    '& > svg': {
      height: '100%',
    },
  },
  logoLink: {
    display: 'inline-block',
    height: '100%',
    paddingTop: '0.75em',
    paddingBottom: '0.75em',
  },
}));

const PageLayout: FC<PropsWithChildren> = ({ children }) => {
  const { classes } = useStyles();

  const left = (
    <Grid container spacing={1} alignItems="center" sx={{ height: '100%' }}>
      <Grid item sx={{ height: '100%' }}>
        <Link href="/" className={classes.logoLink}>
          <img className={classes.logo} src="/images/logo.svg" />
        </Link>
      </Grid>
    </Grid>
  );

  return (
    <Snackbar>
      <div className={classes.ieFlexboxFix}>
        <div className={classes.flexibleFooter}>
          <div className={classes.appFrame}>
            <ThemeProvider theme={factbird.dark}>
              <Header left={left} right={null} />
            </ThemeProvider>
            <div className={classes.content}>{children}</div>
          </div>
          <ThemeProvider theme={factbird.dark}>
            <Footer />
          </ThemeProvider>
        </div>
      </div>
    </Snackbar>
  );
};

export default PageLayout;
